import {Component, OnInit} from '@angular/core';
import {LangSwitcherService} from '../../lang-switcher.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  lang: string;
  currLang: string;
  constructor(private langSwitcherService: LangSwitcherService, private translateService: TranslateService) {
  }

  ngOnInit(): void {
    const lang = localStorage.getItem('lang');
    this.lang = lang ? lang : 'ru';
  }

  setLanguage(languageCode: string): void {
    this.currLang = this.translateService.currentLang;
    this.translateService.use(languageCode);
    this.langSwitcherService.setActiveLang(languageCode);
  }

}
